// extracted by mini-css-extract-plugin
module.exports = {"custom_table":"CustomTable_custom_table__lLjIU","nodata":"CustomTable_nodata__3gSYA"};